import {IRaiseTextProps} from './RaiseText.types';

export type {IRaiseTextProps};
export {default as RaiseText} from './RaiseText';
